import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, UntypedFormBuilder } from '@angular/forms';
import { MatFormFieldControl } from '@angular/material/form-field';
import { ProducerFileUploadService } from 'src/app/angular-elements/form-wrappers/form-components/producer-file-upload/producer-file-upload/services/producer-file-upload.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-producer-file-upload',
    templateUrl: './producer-file-upload.component.html',
    styleUrls: ['./producer-file-upload.component.scss'],
    providers: [{
            provide: MatFormFieldControl,
            useExisting: ProducerFileUploadComponent
        }],
    standalone: false
})
export class ProducerFileUploadComponent implements OnInit, OnDestroy {
  @Output() filesInFormData = new EventEmitter<FormData[]>();

  /** Used for HTML display - table of files */
  attachments: FileList;
  attachmentsInFormDataFormat: FormData;

  soaUploadForm: UntypedFormGroup;
  formChanges: Subscription;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private producerFileUploadService: ProducerFileUploadService
  ) {
    this.soaUploadForm = this.formBuilder.group({
      fileUploader: new UntypedFormControl()
    });

  }

  ngOnInit() {
    this.formChanges = this.soaUploadForm.valueChanges.subscribe( changes => {
    });
  }

  pdfInputChange(event: Event) {

    const fileUploadInput: HTMLInputElement = event.target as HTMLInputElement;
    const files: FileList = fileUploadInput.files;

    const fileName = fileUploadInput.value;

    /** Set files for HTML display */
    this.attachments = files;
    /** Pass to service for later used in submission */
    this.producerFileUploadService.setFilesForUpload(files);
  }

  ngOnDestroy() {
    this.formChanges.unsubscribe();
  }
}
